import { useTitle } from 'ahooks';

import { Loader } from 'components/loader';
import { useScreenTracking } from 'services/analytics';
import './FullscreenSpinner.scss';

const FullscreenSpinner = ({ children }: { children?: JSX.Element }) => {
  useTitle('Loading - NightOwl');
  // GA Analytics: Log screen view
  useScreenTracking({ screenName: 'Loading', screenClass: 'FullscreenSpinner' });
  return (
    <div className="fullscreenspinner">
      <div className="loader-holder">{children || <Loader />}</div>
    </div>
  );
};

export default FullscreenSpinner;
